import { render, staticRenderFns } from "./placeTagCloud.vue?vue&type=template&id=61d2db5e&scoped=true"
import script from "./placeTagCloud.vue?vue&type=script&lang=js"
export * from "./placeTagCloud.vue?vue&type=script&lang=js"
import style0 from "./placeTagCloud.vue?vue&type=style&index=0&id=61d2db5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d2db5e",
  null
  
)

export default component.exports